"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import styles from "./designer.module.css";

export function DesignerFollowButton({ designerId, locale, label }: Readonly<{ designerId: string; locale: string; label: string }>) {
  const router = useRouter();
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  async function follow() {
    if (busy) {
      return;
    }
    setBusy(true);
    setMessage("");
    try {
      const response = await fetch(`/api/designers/${encodeURIComponent(designerId)}/follow`, { method: "POST" });
      const result = (await response.json()) as { ok?: boolean; status?: string; message?: string };
      if (result.ok) {
        setMessage(locale === "en-US" ? "Followed." : "\u5df2\u5173\u6ce8\u3002");
        return;
      }
      if (result.status === "auth-required") {
        router.push(`/auth?mode=login&lang=${locale}&returnUrl=${encodeURIComponent(`/designer/${designerId}?lang=${locale}`)}`);
        return;
      }
      setMessage(locale === "en-US" ? "Follow failed. Please try again." : "\u5173\u6ce8\u5931\u8d25\uff0c\u8bf7\u7a0d\u540e\u91cd\u8bd5\u3002");
    } catch {
      setMessage(locale === "en-US" ? "The service is temporarily unavailable. Please try again." : "服务暂不可用，请稍后重试。");
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className={styles.followWrap}>
      <button type="button" disabled={busy} onClick={follow}>{label}</button>
      {message ? <em>{message}</em> : null}
    </span>
  );
}
